import { useEffect, useState } from 'react';

const useIsOnline = () => {
  const [status, setStatus] = useState(
    typeof navigator.onLine !== 'undefined' ? navigator.onLine : true,
  );

  const handleChange = () => {
    setStatus(navigator.onLine);
  };

  useEffect(() => {
    window.addEventListener('online', handleChange);
    window.addEventListener('offline', handleChange);
    return () => {
      window.removeEventListener('online', handleChange);
      window.removeEventListener('offline', handleChange);
    };
  }, []);

  return status;
};

export default useIsOnline;
